module.exports = __webpack_public_path__ + "img/ax_house.5866c1a0.png";